import {config, IJsonRpcResponse} from "../api";

interface ICycleDayChangeResponse extends IJsonRpcResponse {
    result: {
        success: boolean;
        message: string;
    }
}

export const changeCycleDay = async (
    cycleDay: number,
    customerID: number
) => {
    const params = {
        customerID,
        cycleDay
    };
    const authToken = config.authToken;
    const res = await fetch(`${config.url}/changeCycleDay`, {
        body: JSON.stringify(params),
        headers: {
            'Authorization': 'Bearer ' + authToken,
            'Content-Type': 'application/json'
        },
        method: 'post',
        mode: 'cors'
    });
    const response: ICycleDayChangeResponse = await res.json();
    return response.result;
};
